import 'bootstrap';

import initLayout from './js/layout';
import initServiceSearch from './js/components/service-search';
import initHomeTestimonials from './js/components/home-testimonials';
import initContactForm from './js/components/contact-form';
import initBlogShare from './js/components/blog-share';
import initContactMap from './js/components/contact-map';
import initApplicationForm from './js/components/application-form';
import initDestinationCategories from './js/components/destination-categories';
import initDestinationScrollspy from './js/components/destination-scrollspy';
import initDestinationDocuments from './js/components/destination-documents';
import initCookieNotice from './js/components/cookie-notice';
import initVisaPrices from './js/components/visa-prices';

window.vizaAzInitContactMap = initContactMap;

(function ($) {
  'use strict';

  $(function () {
    initLayout($);
    initServiceSearch();
    initHomeTestimonials();
    initContactForm();
    initBlogShare();
    initContactMap();
    initApplicationForm();
    initDestinationCategories();
    initDestinationScrollspy();
    initDestinationDocuments();
    initCookieNotice();
    initVisaPrices();
  });
})(jQuery);
